import { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme: any) => ({
    
    main: {
        maxWidth: '250px',
        margin : '20px auto',
        fontSize: '10px',
        textAlign: 'center',
        color: '#6E7FA6'
    }
}))

function Copyright() {
    const { classes } = useStyles();
    const [date, setDate] = useState(0)

    useEffect(() => {
        const currentYear = new Date().getFullYear();
        setDate(currentYear)
    }, [])
    

    return (
        <div className={classes.main}>
            Copyright Voxel Farm © {date}
        </div>
  );
}

export { Copyright };
